@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../app-brand/concepts/shipstation-concept-layer-default.module.less';

@leftNavOpenWidth: 240px;
@leftNavClosedWidth: 32px;

@LeftNavClosed: {
  &.hide-left-nav {
    width: @leftNavClosedWidth;
    min-width: @leftNavClosedWidth;

    // hide all contents
    * {
      display: none;
    }
  }
};

@leftOffsetToEnsureToggleIconBisectsLeftNavBorder: 229px;

@ToggleIcon: {
  // open
  .icon-styles {
    height: 16px;
    width: 16px;
    background: var(--left-nav--toggle-icon--background-color);
    border-radius: 50%;
  }

  // closed
  &.left-nav-toggle-wrapper-left {
    left: 22px;
    transform: rotate(180deg);
  }
};

.left-nav-toggle-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 20px;
  height: 20px;

  position: absolute;
  left: @leftOffsetToEnsureToggleIconBisectsLeftNavBorder;
  top: 18px;

  &:hover {
    cursor: pointer;
  }

  @ToggleIcon();
}

.left-nav {
  position: relative;
  border-right: 1px solid var(--left-nav--border-color);
  width: @leftNavOpenWidth;
  min-width: @leftNavOpenWidth;

  @LeftNavClosed();
}
